import React from 'react'
import { cardStyle, white, accent, accentShadow, textPrimary, borderDefault } from './styles'

function CurrentCard({ event, selectedZone, onPlaceClick, isLoading }) {
  const isDisabled = selectedZone === null || isLoading

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: white,
        borderTop: `2px solid ${borderDefault}`,
        padding: '12px 16px',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        zIndex: 100,
      }}
    >
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ marginBottom: '12px' }}>
          <div style={{ fontSize: '0.7rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#aaa', marginBottom: '4px' }}>Current Event</div>
          <div style={{ fontSize: '1.1rem', fontWeight: '600', color: textPrimary, marginBottom: '4px' }}>{event.title}</div>
          <div style={{ fontSize: '0.9rem', color: '#666', fontWeight: '600' }}>Year: ???</div>
        </div>

        <button
          onClick={onPlaceClick}
          disabled={isDisabled}
          style={{
            width: '100%',
            padding: '13px',
            fontSize: '1rem',
            fontWeight: 'bold',
            backgroundColor: isDisabled ? '#d1d5db' : accent,
            color: white,
            border: 'none',
            borderRadius: '8px',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            boxShadow: isDisabled ? 'none' : `0 2px 0 ${accentShadow}`,
            transition: 'all 0.1s ease',
            opacity: isDisabled ? 0.6 : 1,
            fontFamily: 'inherit',
          }}
        >
          {isLoading ? 'Placing...' : 'Place'}
        </button>
      </div>
    </div>
  )
}

export default CurrentCard
